<template>
    <div>
      <transition name="view" appear enter-active-class="animated fadeInUp delay">
      <div>
        <div class="row">
          <div class="col-md-12">
            <to-pay-table v-if="isPayments" :payments="payments" @to-payroll="toPay"></to-pay-table>
          </div>
        </div>
        <progress-bar :value="progressValue"></progress-bar>
      </div>
      </transition>
    </div>
</template>

<script>
  import {url} from "../plugins/axios";
  import ToPayTable from "./Compensation/ToPayTable";
  import NotificationTemplate from "./Notifications/NotificationTemplate";
  import axios from "axios";
  import {setCookie} from "../plugins/axios";
  import ProgressBar from "../components/Progress";
  export default {
    name: "Compensation",
    components: {ToPayTable, ProgressBar},
    data(){
      return{
        payments:[],
        progressValue:0,
        isPayments: false,
      }
    },
    created() {
      this.getPayments();
    },
    methods: {
      notifyVue(type,message) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: type,
          message:message,
          timeout: 1500
        });
      },
      getPayments(){
        this.isPayments = false;
        axios
          .get(url + 'payments/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.payments = response.data.result;
              this.isPayments = true;
            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
      },
      toPay(id){
        axios
          .get(url + 'pay-employee/' + id + '/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){

            }
            else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          })
          .catch((error) => {
            this.notifyVue('danger',error);
          });
        this.getPayments();
      }
    },
  }
</script>

<style scoped>
  .delay{
    animation-delay: 1.0s;
  }
</style>
